// función de Cantidades en cada producto.

function clampAndUpdate($input) {
  const min = parseInt($input.attr('min')) || 1;
  const max = parseInt($input.attr('max')) || 9999;
  let value = parseInt($input.val());

  if (isNaN(value)) value = min;
  if (value < min) value = min;
  if (value > max) value = max;

  $input.val(value);

  const $container = $input.closest('.quantity-control');
  const $minus = $container.find('.quantity-minus');
  const $plus = $container.find('.quantity-plus');

  $minus.prop('disabled', value <= min);
  $plus.prop('disabled', value >= max);
}

$(document).on('click', '.quantity-plus', function () {
  const $input = $(this).siblings('.quantity-input');
  let value = parseInt($input.val()) || 1;
  $input.val(value + 1);
  clampAndUpdate($input);
});

$(document).on('click', '.quantity-minus', function () {
  const $input = $(this).siblings('.quantity-input');
  let value = parseInt($input.val()) || 1;
  $input.val(value - 1);
  clampAndUpdate($input);
});

$(document).on('input', '.quantity-input', function () {
  clampAndUpdate($(this));
});

$(document).on('blur', '.quantity-input', function () {
  clampAndUpdate($(this));
});

$(document).ready(function () {
  $('.quantity-input').each(function () {
    clampAndUpdate($(this));
  });
});



// Función efecto ADD TO CART

function animateFlyToCartFromButton(buttonElement, targetSelector = '#cart-drawer-toggle') {
  const target = document.querySelector(targetSelector);
  if (!buttonElement || !target) return;

  const rectStart = buttonElement.getBoundingClientRect();
  const rectEnd = target.getBoundingClientRect();

  const flyEl = document.createElement('div');
  flyEl.classList.add('fly-to-cart-blob');
  flyEl.style.position = 'fixed';
  flyEl.style.top = `${rectStart.top}px`;
  flyEl.style.left = `${rectStart.left}px`;
  flyEl.style.width = `30px`;
  flyEl.style.height = `30px`;
  flyEl.style.borderRadius = '50%';
  flyEl.style.background = '#000'; // o un color de marca
  flyEl.style.zIndex = '9999';
  flyEl.style.pointerEvents = 'none';
  document.body.appendChild(flyEl);

  gsap.to(flyEl, {
    top: rectEnd.top + 'px',
    left: rectEnd.left + 'px',
    scale: 0.5,
    opacity: 0,
    duration: 1,
    ease: 'power2.inOut',
    onComplete: () => flyEl.remove()
  });
}





// Función de ADD TO CART

function addToCart(buttonElement, variantId) {
  const wrapper = buttonElement.closest('product-card.product-card .call-to-action');
  const quantityInput = wrapper.querySelector('.quantity-input');

  let quantity = 1;
  if (quantityInput && quantityInput.value) {
    quantity = parseInt(quantityInput.value, 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;
  }

  const originalText = buttonElement.innerText;
  buttonElement.innerText = 'ADDING...';
  buttonElement.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => {
    if (!response.ok) throw new Error('Error al agregar al carrito');
    return response.json();
  })
  .then(data => {
    console.log('Producto agregado:', data);
    animateFlyToCartFromButton(buttonElement);
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    buttonElement.innerText = 'ADDED!';
    
     setTimeout(() => {
      buttonElement.innerText = originalText;
      buttonElement.disabled = false;
    }, 1000);
  })
  .catch(error => {
    console.error('Error:', error);
    setTimeout(() => {
      buttonElement.innerText = originalText;
      buttonElement.disabled = false;
    }, 1000);
  });
}


// Función para Filtros.

function initializeListJS() {
  const productItems = document.querySelectorAll('#product-grid li.column');
  const productCount = productItems.length;
  const facetLabels = document.querySelectorAll('.facets__label');

  // Actualizar texto y guardar original
  facetLabels.forEach(label => {
    label.textContent = `${productCount} products`;
    label.dataset.originalText = label.textContent;
  });

  // Inicializar List.js
  window.productList = new List('ProductGridContainer', {
    valueNames: [{ data: ['title'] }]
  });

  const noResults = document.querySelector('.no-results');

  productList.on('updated', function (list) {
    const searchInput = document.querySelector('.search');
    const isSearching = searchInput && searchInput.value.trim().length > 0;
    const matchCount = list.matchingItems.length;

    if (noResults) {
      noResults.style.display = matchCount === 0 ? 'block' : 'none';
    }

    facetLabels.forEach(label => {
      if (isSearching) {
        label.textContent = `${matchCount} products`;
      } else if (label.dataset.originalText) {
        label.textContent = label.dataset.originalText;
      }
    });
  });
}

// 1. Ejecutar al cargar
$(document).ready(function () {
  initializeListJS();
});

// 2. Usar MutationObserver para detectar cambios
const observerTarget = document.querySelector('#ProductGridContainer');

if (observerTarget) {
  const gridObserver = new MutationObserver((mutationsList, observer) => {
    // console.log('[Observer] Cambios detectados en el grid. Reinicializando List.js...');
    initializeListJS();
  });

  gridObserver.observe(observerTarget, {
    childList: true,
    subtree: false // No hace falta observar en profundidad
  });
}